import React from "react";
import { Icon } from "components/index";
import classNames from "classnames";
import { PENDING, SUBMITTED } from "icons";

const PerformanceStatusCell = ({ getValue, className }) => {
  if (!getValue()) return null;
  return (
    <div className={classNames("flex items-center gap-2 text-sm", className)}>
      <Icon
        icon={getValue() === "pending" ? PENDING : SUBMITTED}
        className={classNames("h-4 w-4", {
          "text-amber-500": getValue() === "pending",
          "text-green-500": getValue() !== "pending",
        })}
      />
      <span className="capitalize">{getValue()}</span>
    </div>
  );
};

export default PerformanceStatusCell;
